import React from 'react';
import * as Styled from './MBlockquote.styles';
import { type MBlockquoteProps, MBlockquoteAlignment } from './MBlockquote.types';
import { ABlockquote } from '../../atoms/ABlockquote/index';
import { ABody, ABodySize, ABodyColor } from '../../atoms/ABody/index';
import { AIcon, AIconSize } from '../../atoms/AIcon';

const COMPONENT_NAME = 'a-web-ui-kit-MBlockquote';
const TEST_ID = 'web-ui-kit-MBlockquote';

function MBlockquote({
  alignment = MBlockquoteAlignment.Left,
  quoteIcon = true,
  blockquoteText = '',
  bodyText = '',
  bodyColor = ABodyColor.Default,
  bodySize = ABodySize.S,
  ...rest
}: MBlockquoteProps) {
  return (
    <Styled.MBlockquoteWrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      alignment={alignment}
      {...rest}
    >
      {quoteIcon && <AIcon icon="icon-quote-mark" size={AIconSize.XXXL} />}
      {blockquoteText.trim().length > 0 && <ABlockquote text={blockquoteText} />}
      {bodyText.trim().length > 0 && <ABody bodyText={bodyText} size={bodySize} color={bodyColor} />}
    </Styled.MBlockquoteWrapper>
  );
}

export { MBlockquote, MBlockquoteAlignment, TEST_ID as M_BLOCKQUOTE_TEST_ID };
